module.exports = {"failed":"로그인 정보가 기록과 일치하지 않습니다.","throttle":"로그인 시도가 너무 많습니다. :seconds초 후 다시 시도하세요."};